/**
 * First-party analytics switch (src/lib/analytics.ts and the one-time
 * privacy notice).
 *
 * OFF until Nic explicitly approves turning it on. Enzo's published Privacy
 * Policy (/privacy-policy/, src/content/legal/privacy-policy.html) covers
 * cookies, unique device identifiers and Usage Data (IP, pages, time on
 * page, referring pages). While off, the site sends no tracking data and
 * forms send no analytics IDs, so leads are not linked to journeys.
 *
 * Turn on by setting VITE_ANALYTICS_ENABLED=true for Production in Vercel
 * and redeploying (see docs/release-checklist-rebuilds-analytics.md).
 */
export const ANALYTICS_ENABLED = import.meta.env.VITE_ANALYTICS_ENABLED === "true";
